<template>
    <div class="clearfix">
    <div class="col-12 px0">
      <div v-if="reviewslength">
        <div class="clearfix p3 my3 lightgrey-background flex justify-start items-center">
          <p class="h5 darkblue mb0 line-height-golden">Ingen anbefalinger</p>
        </div>
      </div>
    </div>
    <div class="col-12 px0">
      <div v-if="loading">
        <div class="loader"></div>
      </div>
    </div>
    <div class="flex flex-wrap" v-if="reviews !== 0">
      <div class="mx1 mb3 border muted-border shadow p3" v-for="review in reviews" :key="review.id">
        <div class="flex flex-column mt1">
          <div class="flex justify-between items-center">
            <div>
              <image-rating v-model="review.Rating" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="22" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
            </div>
            <div>
              <span v-if="review.AssignmentDistributedCount === 1" class="green">
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
              </span>
              <span v-else class="mediumgrey">
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
              </span>
            </div>
          </div>
        </div>
        <div class="mb3">
          <!-- moment(item.appointment_date).format('DD/MM/YY') -->
          <p class="h6 darkblue mb0 relative">{{ moment(review.RatedDate).format('ll') }}</p>
        </div>
        <div>
          <p class="h3 darkblue semi-bold my2 line-height-golden">{{ review.RatedBy }}</p>
        </div>
        <div class="">
          <div class="clearfix flex flex-column">
            <div class="line-height-golden">
              <a href="javascript:void(0)" class="block outlined-primary-button p1 px2 col-12 not-rounded gibson h5 mb2 flex justify-start items-center pointer no-hover" @click="showItemDetails(review)">
                <span class="relative mr1" style="top:6px;">
                  <svg fill="currentColor" height="36" viewBox="0 -75 512 512" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m446.019531 300.152344h-38c-5.519531 0-10-4.476563-10-10v-26.960938c0-6.78125-5.511719-12.292968-12.292969-12.292968h-6.53125v20.785156c0 7.183594-4.578124 13.527344-11.398437 15.789062-6.816406 2.253906-14.28125-.09375-18.570313-5.855468l-36.867187-49.503907c-4.960937-6.664062-4.960937-15.96875 0-22.628906l36.871094-49.507813c4.285156-5.757812 11.75-8.109374 18.566406-5.851562 6.820313 2.257812 11.398437 8.605469 11.398437 15.785156v22.984375h12.355469c35.550781 0 64.472657 28.921875 64.472657 64.472657v32.78125c-.003907 5.527343-4.480469 10.003906-10.003907 10.003906zm-28-20h18v-22.785156c0-24.519532-19.949219-44.46875-44.46875-44.46875h-18.929687c-7.402344 0-13.425782-6.023438-13.425782-13.429688v-19.394531l-30.328124 40.722656 30.328124 40.722656v-17.195312c0-7.402344 6.023438-13.425781 13.425782-13.425781h13.105468c17.808594 0 32.292969 14.484374 32.292969 32.292968zm0 0"/><path d="m66.105469 153.820312c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10h.023437c5.523438 0 9.988282-4.476562 9.988282-10 0-5.519531-4.488282-10-10.011719-10zm0 0"/><path d="m385.480469 108.523438c-3.675781 0-7.320313.15625-10.917969.46875v-67.351563c0-11.679687-4.835938-22.25-12.605469-29.820313-.121093-.125-.246093-.253906-.375-.375-7.773437-7.378906-17.953125-11.445312-28.660156-11.445312h-291.28125c-10.710937 0-20.886719 4.066406-28.664063 11.445312-.128906.125-.253906.25-.375.375-7.769531 7.570313-12.601562 18.140626-12.601562 29.820313v161.761719c0 10.492187 3.902344 20.089844 10.328125 27.417968.144531.183594.292969.363282.453125.539063 2.96875 3.273437 6.414062 6.023437 10.183594 8.175781 6.09375 3.503906 13.152344 5.507813 20.675781 5.507813h217.714844c5.113281 65.105469 59.730469 116.519531 126.125 116.519531 69.761719-.003906 126.519531-56.757812 126.519531-126.519531s-56.757812-126.519531-126.519531-126.519531zm-132.148438-13.785157-49.570312 43.707031c-4.699219 4.144532-10.589844 6.214844-16.480469 6.214844-4.511719 0-9.019531-1.210937-12.996094-3.640625-.242187-.148437-.484375-.300781-.722656-.460937-.402344-.261719-.792969-.539063-1.179688-.828125-.539062-.402344-1.070312-.832031-1.582031-1.285157l-49.570312-43.707031c-.003907 0-.003907 0-.003907 0l-84.203124-74.242187c1.488281-.324219 3.03125-.496094 4.617187-.496094h291.28125c1.582031 0 3.128906.171875 4.613281.496094l-84.164062 74.207031c-.011719.015625-.027344.023437-.039063.035156zm99.65625-61.203125c1.015625 2.503906 1.574219 5.242188 1.574219 8.105469v70.6875c-19.84375 4.96875-37.648438 14.519531-52.363281 27.386719l-28.542969-36.230469zm-311.648437 191.503906c-.015625 0-.03125 0-.042969 0-.085937 0-.171875-.003906-.257813-.003906-.015624 0-.027343-.003906-.046874-.003906-3.039063-.089844-6.003907-.824219-8.707032-2.121094l15.621094-19.824218c3.417969-4.339844 2.671875-10.625-1.667969-14.046876-4.335937-3.414062-10.625-2.667968-14.042969 1.667969l-12.039062 15.285157c-.101562-.847657-.15625-1.710938-.15625-2.589844v-161.761719c0-2.863281.558594-5.601563 1.574219-8.105469l79.332031 69.949219-16.78125 21.300781c-3.417969 4.339844-2.671875 10.625 1.667969 14.042969 4.339843 3.417969 10.625 2.675781 14.042969-1.664063l16.09375-20.433593 41.644531 36.71875c14.6875 12.949219 35.851562 14.667969 52.261719 5.152343 2.507812-1.453124 4.90625-3.171874 7.152343-5.152343l41.644531-36.71875 29.488282 37.433593c-6.953125 8.382813-12.832032 17.660157-17.445313 27.617188-.019531.039062-.035156.078125-.054687.117188-.03125.074218-.066406.144531-.101563.21875-6.195312 13.441406-9.992187 27.941406-11.164062 42.921874h-217.714844c-.101563.003907-.199219 0-.300781 0zm344.140625 116.519532c-58.734375 0-106.519531-47.78125-106.519531-106.519532 0-.214843.003906-.429687.003906-.644531 0-.070312 0-.144531 0-.214843.003906-.148438.003906-.292969.003906-.441407.003906-.070312.003906-.140625.003906-.210937 0-.011719 0-.019532 0-.027344.003906-.140625.003906-.285156.007813-.425781 0-.066407.003906-.136719.003906-.203125 0-.011719 0-.023438 0-.039063.003906-.136719.007813-.273437.007813-.410156.003906-.0625.003906-.121094.007812-.183594 0-.027343 0-.058593 0-.085937.003906-.136719.007812-.277344.011719-.417969.003906-.035156.003906-.074219.003906-.109375 0-.046875.003906-.089844.003906-.136719.003907-.160156.011719-.320312.015625-.480469 0-.007812.003906-.019531.003906-.027343 0-.042969 0-.085938.003907-.132813.007812-.191406.015625-.382812.023437-.574218 0-.015626 0-.035157.003906-.050782 2.527344-56.507812 49.289063-101.699218 106.410157-101.699218 58.734375 0 106.519531 47.78125 106.519531 106.515624 0 58.738282-47.785156 106.519532-106.519531 106.519532zm0 0"/></svg>
                </span>
                <span class="h6 semi-bold mb0 line-height-1 pl1">Læs og besvar</span>
              </a>
            </div>
            <div class="line-height-golden">
              <a class="block outlined-dark-button p1 pl2 flex justify-start items-center gibson border-none not-rounded mb1 pointer" @click="downloadItemDetails(review,0)">
                <span class="relative mr1" style="top:4px;">
                  <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M406 187.5c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 160 0 214.4 0 281.3s54.4 121.3 121.3 121.3h44.5c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5s44.6-99.5 99.5-99.5c2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.4 8.6-0.4 8.6 -0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.3 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-48.9c-6 0-10.9 4.9-10.9 10.9s4.9 10.9 10.9 10.9h48.9c59.3 0 107.6-48.3 107.6-107.6C512 236.3 464.6 188.3 406 187.5z"/><path d="M262.8 97.5c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 6.4 0.9 11.5-3.9 12.3-9.3 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 102.4 268.8 97.5 262.8 97.5z"/><path d="M313.3 410.3c-4-4.5-10.9-4.9-15.4-0.9l-26.3 23.5V298.5c0-6-4.9-10.9-10.9-10.9 -6 0-10.9 4.9-10.9 10.9v134.3l-26.3-23.5c-4.5-4-11.4-3.6-15.4 0.9 -4 4.5-3.6 11.4 0.9 15.4l39.7 35.5c3.4 3.1 7.7 4.6 12 4.6 4.3 0 8.6-1.5 12-4.6l39.7-35.5C316.9 421.7 317.3 414.8 313.3 410.3z"/></svg>
                </span>
                <span class="h6 semi-bold mb0 line-height-1 pl1">Gem billede af anbefalingen</span>
              </a>
            </div>
          </div>
          <button href="javascript:void(0)" class="col-12 facebook-button p1 py2 mt1 pointer no-hover flex justify-start items-center" @click="downloadItemDetails(review,1)">
            <span class="mr1 relative" style="top:-4px;">
              <img src="/static/svg/facebook.svg" alt="" width="20" height="20">
            </span>
            <span class="h6 semi-bold mb0 white left-align pl1">Del anbefaling på Facebook</span>
          </button>
        </div>
      </div>
    </div>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <b-modal centered  v-model="reviewShow" ref="reviewModal">
          <!-- header -->
          <div  class="clearfix px2 mb1">
            <div class="h6 darkblue semi-bold gibson pt2">
              Din kunde <strong>{{ sampleReview.name }}</strong> har givet dig følgende vurdering
            </div>
          </div>
          <div class="modal-content px2 gibson" style="border:0;">
            <!-- time -->
            <div class="flex justify-between items-center mb2">
              <span class="h6 regular darkblue mb0" style="font-size:0.75rem;">Overholdte tidsaftaler</span>
              <span>
                <image-rating :v-model="sampleReview.time" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
              </span>
            </div>
            <!-- listen -->
            <div class="flex justify-between items-center mb2">
              <span class="h6 regular darkblue mb0" style="font-size:0.75rem;">Lyttede til mine ønsker</span>
              <span>
                <image-rating v-model="sampleReview.listen" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
              </span>
            </div>
            <!-- bargain -->
            <div class="flex justify-between items-center mb2">
              <span class="h6 regular darkblue mb0" style="font-size:0.75rem;">Overholdte økonomiske aftaler</span>
              <span>
                <image-rating v-model="sampleReview.bargain" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
              </span>
            </div>
            <!-- clean -->
            <div class="flex justify-between items-center mb2">
              <span class="h6 regular darkblue mb0" style="font-size:0.75rem;">Ryddedde op efter sig</span>
              <span>
                <image-rating v-model="sampleReview.clean" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
              </span>
            </div>
            <!-- quality -->
            <div class="flex justify-between items-center mb2">
              <span class="h6 regular darkblue mb0" style="font-size:0.75rem;">Leverede kvalitetsarbejde</span>
              <span>
                <image-rating v-model="sampleReview.quality" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
              </span>
            </div>
            <!-- recommend -->
            <div class="flex justify-between items-center mb2">
              <span class="h6 regular darkblue mb0" style="font-size:0.75rem;">På en skala – vil du anbefale os?</span>
              <span>
                <image-rating v-model="sampleReview.recommend" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
              </span>
            </div>
            <!-- total -->
            <div class="flex justify-between items-center mb2">
              <span class="h6 regular darkblue mb0" style="font-size:0.75rem;">Samlet vurdering</span>
              <span>
                <image-rating v-model="sampleReview.total" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
              </span>
            </div>
            <div class="my2">
              <div class="h6 darkblue semi-bold mb2">{{ sampleReview.AssignmentTitle }}</div>
              <div v-html="sampleReview.RatingComment" class="darkblue line-height-golden" style="font-size:0.75rem;"></div>
            </div>
            <!-- response -->
            <div class="flex flex-column">
              <div class="h6 darkblue semi-bold mb2">Kommentar</div>
              <textarea variant="secondary" id="textarea1" v-model="sampleReview.SupplierRatingComment"  placeholder="Skriv en kommentar til anbefalingen her" :rows="2" :max-rows="6" class="darkblue lightgrey-background line-height-golden" style="border:0;font-size:0.75rem;">
              </textarea>
            </div>
          </div>
          <!-- modalFooter -->
          <div slot="modal-footer" class="col-12 flex justify-between items-center gibson pb3">
            <button type="button" slot="modal-cancel" class="standard-button px2 py1" @click="hideModal">
              <span class="h6 semi-bold mb0" style="font-size:0.75rem;">Luk</span>
            </button>
            <button type="button" class="standard-button px2 py1">
              <span class="h6 semi-bold mb0" style="font-size:0.75rem;">Rapporter til CS</span>
            </button>
            <button type="submit" slot="modal-ok" class="action-button px2 py1" @click="review_service(sampleReview)" :disabled="isLoadingReview">
              <span class="h6 semi-bold mb0" style="font-size:0.75rem;">Gem kommentar</span>
            </button>
          </div>
        </b-modal>
    </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import StarRating from 'vue-star-rating'
import {ImageRating} from 'vue-rate-it'
export default {
  name: 'reviewsdesktop',
  components: {
    StarRating,
    loading,
    Simplert,
    ImageRating
  },
  props: ['id'],
  data () {
    return {
      rating: 0,
      show: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      overlay: 1,
      reviews: [],
      reviewShow: false,
      reviewslength: false,
      text: '',
      sampleReview: []
    }
  },
  created () {
    this.Reload()
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      if (localStorage.getItem('haaid') === '0') {
        this.loading = false
        return
      }
      var data = {operation: 'anbefalinger', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.loading = false
            this.reviews = res
            this.show = false
            if (this.reviews.length === 0) {
              this.reviewslength = true
            }
          },
          response => {
            alert('error')
          }
        )
    },
    review_service (item) {
      this.isLoadingReview = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'review_service', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: item.SupplierRatingComment}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            if (res.success) {
              alert('Gennemført!')
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showItemDetails (review) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.show = true
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'anbefalingerDetail', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.show = false
            this.reviewShow = !this.reviewShow
            this.sampleReview = review
            this.sampleReview.time = parseFloat(res.ContactRating)
            this.sampleReview.listen = parseFloat(res.AgreementRating)
            this.sampleReview.bargain = parseFloat(res.PriceRating)
            this.sampleReview.clean = parseFloat(res.CleaningRating)
            this.sampleReview.quality = parseFloat(res.WorkRating)
            this.sampleReview.recommend = parseFloat(res.RecommendRating)
            this.sampleReview.total = parseFloat(res.Rating)
          },
          response => {
            alert('error')
          }
        )
    },
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.png')
      document.body.appendChild(link)
      link.click()
    },
    downloadItemDetails (review, share) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      this.show = true
      var data = {operation: 'anbefalingerDownload', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId, reviewPic: review.ProfilePicPath}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              if (share === 1) {
                window.open('https://www.facebook.com/sharer/sharer.php?u=https://www.håndværker.dk/microsites/rating.php?id=' + review.ReviewId, '_blank')
              } else {
                const linkSource = 'data:image/jpg;base64,' + encodeURI(res.url)
                const downloadLink = document.createElement('a')
                const fileName = 'anbefaling' + review.ReviewId + '.jpg'
                downloadLink.href = linkSource
                downloadLink.download = fileName
                downloadLink.click()
              }
            } else {
              alert('error')
              this.show = false
            }
          },
          response => {
            alert('error')
            this.show = false
          }
        )
    },
    hideModal () {
      this.reviewShow = false
    },
    setRating (rating) {
      this.sampleReview.rating = rating
    }
  }
}
</script>
<style>
.modal-header,
.modal-footer,
.card-header {
  border-top: 0;
  border-bottom: 0;
  background: none;
  padding-bottom: 0;
}
.vue-star-rating-rating-text {
  display: none;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: rgba(77, 207, 85, 1.0);
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
textarea[placeholder]:focus::-webkit-input-placeholder {
  transition: opacity 0.5s 0.5s ease;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// ReviewsDesktop.vue?713a4df4